// extracted by mini-css-extract-plugin
module.exports = {"people":"style__people___1v-ps","buttons":"style__buttons___1J2RO","person":"style__person___3s-So","personLiteral":"style__person-literal___WKFqT"};